module.exports = __webpack_public_path__ + "static/apple-icon-180x180-d1be33a2643533da708f370529e9d16e.png";